var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showMoreBtn)?_c('div',{class:[
    'l-flex',
    'l-flex--column',
    'l-flex--align-center',
    'u-margin-bottom-large',
  ]},[_c('p',{staticClass:"t-paragraph-large u-margin-bottom-small"},[_vm._v("\n    Showing "+_vm._s(_vm.visibleProducts)+" of "+_vm._s(_vm.totalProducts)+" Products\n  ")]),_vm._v(" "),_c('btn',{attrs:{"text":_vm.buttonText},on:{"click":_vm.loadMoreProducts}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }